var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16665 4.33333H14.8333V1.95833H2.16665V4.33333ZM10.0833 13.0417V5.91667H6.91665V13.0417H10.0833ZM11.6666 13.0417H14.8333V5.91667H11.6666V13.0417ZM5.33331 13.0417V5.91667H2.16665V13.0417H5.33331ZM1.37498 0.375H15.625C15.8349 0.375 16.0363 0.458407 16.1848 0.606874C16.3332 0.75534 16.4166 0.956704 16.4166 1.16667V13.8333C16.4166 14.0433 16.3332 14.2447 16.1848 14.3931C16.0363 14.5416 15.8349 14.625 15.625 14.625H1.37498C1.16502 14.625 0.963653 14.5416 0.815187 14.3931C0.66672 14.2447 0.583313 14.0433 0.583313 13.8333V1.16667C0.583313 0.956704 0.66672 0.75534 0.815187 0.606874C0.963653 0.458407 1.16502 0.375 1.37498 0.375Z",
    fill: "#1B407A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.fea13a4372f1c4b11161b0369b81a1e5.svg";
export { ForwardRef as ReactComponent };